import React, { useCallback } from "react";

import { DeviceTesterActionType } from "../../device-tester-context-provider/Reducer.types";
import { DeviceTesterTestState } from "../../../types/Device.types";
import {
  useDeviceTesterStateContext,
  useDeviceTesterDispatchContext,
} from "../../device-tester-context-provider/DeviceTesterContextProvider";

import { ResultsDesktopAudioTestModal } from "./ResultsDesktopAudioTestModal";
export const ConnectedResultsDesktopAudioTestModal: React.FC = () => {
  const { deviceTesterState } = useDeviceTesterStateContext();
  const { deviceTesterDispatch } = useDeviceTesterDispatchContext();

  const exitAudioTestFlow = useCallback(() => {
    deviceTesterDispatch({
      type: DeviceTesterActionType.SET_DEVICE_TEST_STATE,
      state: DeviceTesterTestState.RESULTS,
    });
  }, [deviceTesterDispatch]);

  return (
    <ResultsDesktopAudioTestModal
      exitAudioTestFlow={exitAudioTestFlow}
      isModalOpen={
        deviceTesterState.deviceTesterTestState === DeviceTesterTestState.AUDIO
      }
    />
  );
};
